'use strict';
import * as $j_app$002edata$002e$002dPurchase$002dOrder$002dContract$002dData$0024package$0024$002dPurchase$002dOrder$002dNumber$002dForm$0024 from "./app.data.-Purchase-Order-Contract-Data$package$-Purchase-Order-Number-Form$.js";
import * as $j_app$002edata$002e$002dPurchase$002dOrder$002dReference from "./app.data.-Purchase-Order-Reference.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_PurchaseOrderReferenceForm$$anon$4() {
}
export { $c_Lapp_data_PurchaseOrderReferenceForm$$anon$4 as $c_Lapp_data_PurchaseOrderReferenceForm$$anon$4 };
$p = $c_Lapp_data_PurchaseOrderReferenceForm$$anon$4.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_PurchaseOrderReferenceForm$$anon$4;
/** @constructor */
function $h_Lapp_data_PurchaseOrderReferenceForm$$anon$4() {
}
export { $h_Lapp_data_PurchaseOrderReferenceForm$$anon$4 as $h_Lapp_data_PurchaseOrderReferenceForm$$anon$4 };
$h_Lapp_data_PurchaseOrderReferenceForm$$anon$4.prototype = $p;
$p.bYJ = (function(src, failFast) {
  var this$1 = $j_app$002edata$002e$002dPurchase$002dOrder$002dContract$002dData$0024package$0024$002dPurchase$002dOrder$002dNumber$002dForm$0024.$m_Lapp_data_PurchaseOrderContractData$package$PurchaseOrderNumberForm$().az().bh(src.FD, failFast);
  matchResult12: {
    var $x_1;
    if ((this$1 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_scalaland_chimney_partial_Result$Value)) {
      var $x_1 = this$1;
      break matchResult12;
    }
    if ((this$1 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_scalaland_chimney_partial_Result$Errors)) {
      var $x_1 = this$1.bo(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_scalaland_chimney_partial_PathElement$Accessor("number"));
      break matchResult12;
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(this$1);
  }
  var this$3 = $x_1;
  if ((this$3 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_scalaland_chimney_partial_Result$Value)) {
    return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_scalaland_chimney_partial_Result$Value(new $j_app$002edata$002e$002dPurchase$002dOrder$002dReference.$c_Lapp_data_PurchaseOrderReference(this$3.a1, src.FC));
  }
  if ((this$3 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_scalaland_chimney_partial_Result$Errors)) {
    return this$3;
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(this$3);
});
$p.bh = (function(src, failFast) {
  return this.bYJ(src, failFast);
});
var $d_Lapp_data_PurchaseOrderReferenceForm$$anon$4 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_PurchaseOrderReferenceForm$$anon$4, "app.data.PurchaseOrderReferenceForm$$anon$4", ({
  F0: 1,
  bz: 1,
  by: 1
}));
export { $d_Lapp_data_PurchaseOrderReferenceForm$$anon$4 as $d_Lapp_data_PurchaseOrderReferenceForm$$anon$4 };
//# sourceMappingURL=app.data.-Purchase-Order-Reference-Form$$anon$4.js.map
